import { render, staticRenderFns } from "./ManageTableGood.vue?vue&type=template&id=4d7eb5a7&scoped=true&"
import script from "./ManageTableGood.vue?vue&type=script&lang=js&"
export * from "./ManageTableGood.vue?vue&type=script&lang=js&"
import style0 from "./ManageTableGood.vue?vue&type=style&index=0&id=4d7eb5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7eb5a7",
  null
  
)

export default component.exports